export default __webpack_public_path__ + "static/media/textBoxFrameSmallBlack.451eacd5.png";